/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

(function() {
    var token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        var op = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(method, url) {
            var resp = op.apply(this, arguments);
            if (typeof url === 'string' && url.includes('maps.googleapis.com')) {
                return resp;
            }
            this.setRequestHeader('X-CSRF-Token', token.content);
            return resp;
        };
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
}());


$(document).ready(function () {
    //

});

// Select2 hehe
$.fn.select2.defaults.set('theme', 'bootstrap-5');

window.addEventListener('load', e => {
    if ('serviceWorker' in navigator) {
        try {
            navigator.serviceWorker.register('/service-worker.js');
        } catch (e) {
            alert('ServiceWorker registration failed.');
        }

        navigator.serviceWorker.ready.then(function(registration) {
            registration.update();
        });
    }
});
